<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          FAQ
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card class="mb-3">
        <v-card-title class="px-5">
          <v-flex xs9 class="pl-1">
            {{ id ? type + ' FAQ' : 'Create FAQ' }}
          </v-flex>
          <v-flex xs3 class="text-right" v-if="isDetail || isEdit">
            <v-icon @click="getDetail" title="refresh">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <v-card-text class="py-0 px-4">
          <v-col cols="4" class="px-2">
            <label class="darkblue--text">Category</label>
            <v-autocomplete
              dense
              id="budgetOwner"
              single-line
              outlined
              :disabled="isDetail"
              label="Select Category"
              v-model="items.category_id"
              required
              item-text="name"
              item-value="id"
              :items="categories"
              autocomplete="off"
            ></v-autocomplete>
          </v-col>
        </v-card-text>
      </v-card>
      <v-card v-for="(faq, index) in items.data" :key="index" class="mb-3">
        <v-card-title class="px-6">
          <h5>Question {{ index + 1 }}</h5>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            small
            dark
            @click="removeQuestion(index)"
            v-if="!isDetail"
          >
            <v-icon large class="icon-medium">delete_outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="px-6">
          <v-col cols="12" class="px-0">
            <v-text-field
              outlined
              v-model="faq.question"
              placeholder="Question"
              :disabled="isDetail"
              required
              dense
            ></v-text-field>
            <label class="darkblue--text font-weight-600">Answer</label>
            <div class=" img-size" v-html="faq.answer" v-if="isDetail"></div>
            <vue-editor
              v-else
              v-model="faq.answer"
              class=""
              :editor-toolbar="customToolbar"
              useCustomImageHandler
              @image-added="handleImageAdded"
            ></vue-editor>
            <!-- <v-textarea
              single-line
              v-model="faq.answer"
              placeholder="Answer"
              :disabled="isDetail"
              required
              dense
              rows="3"
            ></v-textarea> -->
          </v-col>
        </v-card-text>
      </v-card>
      <v-row>
        <v-col cols="6">
          <v-btn color="green" dark @click="addQuestion()" v-if="!isDetail">
            <v-icon>add</v-icon> Add Question
          </v-btn>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-btn
            id="btn-cancel"
            dark
            rounded
            class="px-10"
            color="red"
            :to="{ name: 'faq' }"
          >
            Back
          </v-btn>
          <v-btn
            color="primary ml-3"
            class="px-10"
            rounded
            @click="save()"
            v-if="!isDetail"
          >
            Save
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import 'sweetalert2/src/sweetalert2.scss';
import { VueEditor } from 'vue2-editor';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    'progress-dialog': ProgressDialog,
    VueEditor
  },
  props: ['id', 'type'],
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      loading: true,
      progressDialogLoading: false,
      isDetail: false,
      isEdit: false,
      breadcrumbs: [
        {
          text: 'Content Management',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'FAQ List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text: this.id ? this.type + ' FAQ' : 'Create FAQ',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ header: 1 }, { header: 2 }],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }],
        ['link', 'image'],
        [{ direction: 'rtl' }],
        ['clean']
      ],
      categories: [],
      items: {
        category_id: null,
        data: [
          {
            question: '',
            answer: ''
          }
        ]
      }
    };
  },
  async mounted() {
    await this.getCategory();
    if (this.id) {
      if (this.type === 'Detail') {
        this.isDetail = true;
        this.isEdit = false;
        this.getDetail();
      } else if (this.type === 'Edit') {
        this.isEdit = true;
        this.isDetail = false;
        this.getDetail();
      }
    } else {
      setTimeout(() => {
        this.progressDialogLoading = false;
        this.loading = false;
      }, 800);
    }
  },
  methods: {
    async getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      await this.$store
        .dispatch('support/detailFaq', this.id)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.items.category_id = data.data[0].category_id;
            this.items.data = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    save() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to save this FAQ?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.saveFAQ();
        }
      });
    },
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      if (file.size <= 1000000) {
        this.progressDialogLoading = true;

        var formImage = new FormData();
        formImage.append('images', file);

        this.$store
          .dispatch('texts/upload', formImage)
          .then(data => {
            this.progressDialogLoading = false;
            let url = data.data; // Get url from response
            let base = this.baseUrl + '/images/';
            for (var i = 0; i < url.length; i++) {
              Editor.insertEmbed(
                cursorLocation,
                'image',
                base + url[i].nameFile
              );
            }
            resetUploader();
          })
          .catch(err => {
            console.log(err);
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        Swal.fire(
          'Failed!',
          'Your image is too large. Image size max is 1MB. Please resize your image or change the image to be uploaded.',
          'error'
        );
      }
    },
    saveFAQ() {
      this.progressDialogLoading = true;
      this.$store
        .dispatch('support/createFaq', this.items)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            Swal.fire('Success!', data.message.text_en, 'success');
            this.$router.push({
              name: 'faq'
            });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    addQuestion() {
      this.items.data.push({
        question: '',
        answer: ''
      });
    },
    removeQuestion(index) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'If you delete this question, you can not recover this question.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.items.data.splice(index, 1);
        }
      });
    },
    async getCategory() {
      this.progressDialogLoading = true;
      await this.$store
        .dispatch('category/getAll', {
          paginate: false
        })
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.categories = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
        });
    }
  }
};
</script>
